"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItem = void 0;
var _encoreFoundation = require("@spotify-internal/encore-foundation");
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var ListItem = exports.ListItem = _styledComponents["default"].dd.withConfig({
  displayName: "ListItem",
  componentId: "sc-1id3bok-0"
})(["", ";margin-inline-start:0;@media (max-width:", "){display:inline-block;}"], (0, _index.rootStyle)(), _encoreFoundation.screenXsMax);